module.exports = __webpack_public_path__ + "assets/ef46c89cd923b1996edb79c991d458cd.mp3";